<template>
  <div class="hc-hexasibbling">
    <svg :style="style" class="hc-hexasibbling-chart">
      <complexagon
        v-for="(hex, index) in hexagons"
        :key="index"
        :curve="curve"
        :offColor="colors[index]"
        :scale="hex.scale"
        :y="hex.y"
        :x="hex.x"
        :text="texts[index]"
        :textValue="parseInt(data[index]) + ' ' + unit"
      />
    </svg>
  </div>
</template>

<script>
import Complexagon from '../combo/Complexagon'
import tween from '../libraries/tween'
export default {
  name: 'HexaSibbling',
  components: {
    Complexagon
  },
  props: {
    data: {
      type: Array,
      default () { return []}
    },
    texts: {
      type: Array,
      default () { return []}
    },
    unit: {
      type: String,
      default: 'MD'
    },
    colors: {
      type: Array,
      default () { return ['#666666', '#f56042']}
    },
    curve: {
      type: Number,
      default: .8
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    }
  },
  data () {
    return {
      width: 480,
      height: 360,
      Data: []
    }
  },
  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  created () {
    if (this.animation) {
      tween(
        Object.assign({}, this.data),
        Object.assign({}, this.data.map((d, i, arr) => {return  i ?  arr[i - 1] : arr[i + 1] })),
        this.animationDuration,
        (dataObject) => {
        this.Data = Object.keys(dataObject).map(function (key) { return dataObject[key] })
      }, this.animationOptions)
    } else {
      this.Data = this.data
    }
  },
  watch: {
    data: {
      handler (newData) {
        if (this.animation) {
          tween(
            Object.assign({}, newData),
            Object.assign({}, this.Data),
            this.animationDuration,
            (dataObject) => {
            this.Data = Object.keys(dataObject).map(function (key) { return dataObject[key] })
          }, this.animationOptions)
        } else {
          this.Data = newData
        }
      },
      deep: true
    }
  },
  methods: {
    resize () {
      this.width = this.$el.offsetWidth
      this.height = this.$el.offsetHeight
    }
  },
  computed: {
    style () {
      return { height: `${this.height}px`, width: `${this.width}px` }
    },
    total () {
      return this.data.reduce((a, b) => a + b, 0)
    },
    scale () {
      return 16 * Math.min(this.width / 480, this.height / 360)
    },
    hexagons () {
      let X = 0
      return this.Data.map((d, i) => {
        const scale = d / this.total * this.scale
        if (!i) {
          X = this.width * .02 + scale * 13.856 ** 1.5
        }
        return {
          scale,
          x: i ? X * .95: this.width * .02 + scale * 13.856,
          y: i ? this.height * .97 - scale * 16 :  this.height * .02 + scale * 16
        }
      })
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>

</style>
